import { initNav } from './headerNav'
import { watchScrollVisible } from './scrollVisible'
import './scrollSmooth'
import './homeSlide'
import './sidebar'
import './headerNavMobile'
import { initAjaxzip3OnInput } from '../zzl-lib/ajaxzip3.js'
import './alert'
import { closest } from '../zzl-lib/domClosest'

initNav()
watchScrollVisible()
initAjaxzip3OnInput()

// suppress enter to submit
window.addEventListener('keydown', (event) => {
	if (event.key !== 'Enter') return

	const form = closest('.form-suppress-enter', event.target)
	if (!form) return

	event.preventDefault()
})
